$(function () {
  var galleryThumbs = new Swiper(".gallery-thumbs", {
    centeredSlides: true,
    centeredSlidesBounds: true, 
    spaceBetween: 10,
    slidesPerView: 3,
    freeMode: false,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    watchOverflow: true,
    breakpoints: {
      480: {
        direction: "vertical",
        slidesPerView: 3
      }
    }
  });
  var galleryTop = new Swiper(".gallery-top", {
    direction: "horizontal",
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    a11y: {
      prevSlideMessage: "Previous slide",
      nextSlideMessage: "Next slide",
    },
    keyboard: {
      enabled: true,
    },
    thumbs: {
      swiper: galleryThumbs
    }
  });
  galleryTop.on("slideChangeTransitionStart", function () {
    galleryThumbs.slideTo(galleryTop.activeIndex);
  });
  galleryThumbs.on("transitionStart", function () {
    galleryTop.slideTo(galleryThumbs.activeIndex);
  });
});




var swiper = new Swiper(".fullsection.swiper", {
        navigation:{
          nextEl: ".swiper-button-next",
           prevEl: ".swiper-button-prev",
        },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + "</span>";
        },
      },
    });

// $(document).ready(function(jq){
//   	var shop_name = 'lenovoparts.myshopify.com';
//     jq.ajax({
//       url : "https://fridgeparts.us/lenovopartsapp/admin_ajax.php",
//       type: 'POST',
//       datatype: 'json',
//       data : {
//         action :'testreviews_data',
//         shopname :shop_name
//       },
//       success: function(data){
//         var res = JSON.parse(data);
//         if(data){
//           jq(".new_loader_closed").css("display","none");
//         }
//         // console.log("resres",res)
//         jq(res).each(function(index,value){

//           jq('.review_slide').html(value);
//         })
//         $(".quote_slide").addClass("swiper-slide");
//         var swiper1 = new Swiper(".reviewSlidersection", {
//         slidesPerView: 1,
//         spaceBetween: 10,
//         navigation: {
//         nextEl: ".swiper-button-next", // Class for the "next" button
//         prevEl: ".swiper-button-prev", // Class for the "prev" button
//         },
//         // pagination: {
//         //   el: ".swiper-pagination",
//         //   clickable: true,
//         // },
//         breakpoints: {
//         320: {
//         slidesPerView: 1,
//         spaceBetween: 30,
//         },
//         600: {
//         slidesPerView: 2,
//         spaceBetween: 30,
//         },
//         768: {
//         slidesPerView: 3,
//         spaceBetween: 20,
//         },
//         1440: {
//         slidesPerView: 3,
//         spaceBetween: 31,
//         },
//         1500: {
//         slidesPerView: 4,
//         spaceBetween: 30,
//         },
//         1800: {
//         slidesPerView: 4,
//         spaceBetween: 30,
//         },
//         },
//         });


//       }

//     });


//   })
  $(".slider_class").addClass("swiper-wrapper");
  $(".slider_class > .two_flex_freq").addClass("swiper-slide");

$(document).ready(function () {
  $(".slider_class").addClass("swiper-wrapper");
  $(".slider_class > .two_flex_freq").addClass("swiper-slide");

  // Initialize Swiper
  const swiper2 = new Swiper(".multiple-items", {
    slidesPerView: 1, // Default for smaller screens
    spaceBetween: 20, // Default gap between slides
    navigation: {
      nextEl: ".swiper-button-next", // Next button
      prevEl: ".swiper-button-prev", // Previous button
    },
    breakpoints: {
      320: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
       480: {
          slidesPerView: 2,
          spaceBetween: 15,
        },
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2.5,
          spaceBetween: 24,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1280: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
      1440: {
        slidesPerView: 3,
        spaceBetween: 48, // Adjusted space for 1440px and above
      },
       
    },
  });
});


  $(".collection-slider").addClass("swiper-wrapper");
  $(".product-item").addClass("swiper-slide");

  // Initialize Swiper
  const swiper2 = new Swiper(".slider_related", {
    slidesPerView: 1,
    spaceBetween: 17, 
    navigation: {
      nextEl: ".swiper-button-next", // Next button
      prevEl: ".swiper-button-prev", // Previous button
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        // spaceBetween: 20,
      },
      340: {
        slidesPerView: 2,
        spaceBetween: 25,
      },
        700: {
        slidesPerView: 3,
        spaceBetween: 20,
        },
      1440: {
        slidesPerView: 4,
        spaceBetween: 17, // Adjusted space for 1440px and above
      },
         1800: {
        slidesPerView: 5,
        spaceBetween: 20, // Adjusted space for 1440px and above
      },
    },
  });


    $(".blogpost").addClass("swiper-slide");
        var swiper5 = new Swiper(".blog_dynamic", {
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: {
        nextEl: ".swiper-button-next", // Class for the "next" button
        prevEl: ".swiper-button-prev", // Class for the "prev" button
        },
        // pagination: {
        //   el: ".swiper-pagination",
        //   clickable: true,
        // },
        breakpoints: {
        320: {
        slidesPerView: 1,
        spaceBetween: 30,
        },
        600: {
        slidesPerView: 2,
        spaceBetween: 30,
        },
        768: {
        slidesPerView: 3,
        spaceBetween: 20,
        },
        1440: {
        slidesPerView: 3,
        spaceBetween: 31,
        },
        1500: {
        slidesPerView: 4,
        spaceBetween: 30,
        },
        1800: {
        slidesPerView: 4,
        spaceBetween: 30,
        },
        },
        });



